<template>
  <v-card :class="[{[activeClasses]: isActive}, 'mx-2', {'pb-1': !isActive}]">
    <v-card-title
      class="pa-0 subheading flex-nowrap"
      :class="titleClass"
      :style="{cursor: hideArrow ? 'default' : 'pointer'}"
      v-on="hideArrow ? {} : {click: () => isActive = !isActive}"
    >
      <v-btn
        v-if="!hideArrow"
        icon
        :disabled="disabled"
        @click.stop="isActive = !isActive"
      >
        <rotator 
          state-two="-180"
          :rotated="isActive"
        >
          <v-icon>
            mdi-chevron-down
          </v-icon>
        </rotator>
      </v-btn>
      <slot name="title" />
      <v-spacer />
      <slot
        name="title-right"
        :open="isActive"
      />
    </v-card-title>
    <v-divider />
    <slot name="persistent-content" />
    <v-expand-transition>
      <div v-if="isActive">
        <slot name="outer-content" />
        <v-card-text class="pa-0">
          <slot />
        </v-card-text>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
import touchHelpers from '@/ft-vue-core/mixins/touchHelpers'
import Rotator from '@/ft-vue-core/components/transformers/Rotator'
export default {
  name: 'SimpleExpansionCard',
  components: {Rotator},
  mixins: [touchHelpers],
  props: {
    /** 
     * Set initial value of `isActive`.
     * 
     * NOTE: `isActive` controlled internally after initialization. 
    */
    value: {
      type: Boolean,
      default: true
    },
    /** Classes to be applied when `!!isActive` */
    activeClasses: {
      type: String,
      default: 'pb-1'
    },
    /** Hide the expand collapse arrow from view */
    hideArrow: Boolean,
    disabled: Boolean,
  },
  data () {
    return {
      isActive: false
    }
  },
  computed: {
    /** Classlist from global parameters. Applied to `v-card-title`. */
    titleClass () {
      const classes = {}
      if (this.hasErrors) {
        classes[this.$ftAppIsDark ? this.$ftStyle.dark.sectionTitleError : this.$ftStyle.light.sectionTitleError] = true
      } else {
        classes[(this.$ftAppIsDark ? this.$ftStyle.dark.sectionTitle : this.$ftStyle.light.sectionTitle) + ' test'] = true
      }
      return classes
    },
  },
  mounted () {
    this.isActive = this.value
  },
  methods: {
    /**
     * Method accessible by `ref` to manually set the value of `isActive`
     * @param {Boolean} value New value of `isActive`
     * @see isActive
     */
    setIsActive (value) {
      this.isActive = value
    }
  }
}
</script>
